export function waitUntil(boolFunc: () => boolean, checkInterval: number = 100): Promise<boolean> {
    const waitUntilFunc = (resolve: (value: boolean) => void, boolFunc: () => boolean) => {
        const fulfilledNow = boolFunc()
        if (fulfilledNow) {
            resolve(true)
        }
        else {
            setTimeout(() => {
                waitUntilFunc(resolve, boolFunc)
            }, checkInterval)
        }
    }

    return new Promise<boolean>(resolve => waitUntilFunc(resolve, boolFunc))
}